import Layout from "../Frames/Layout"
import { Stack, Button, Typography } from "@mui/material"
import Top from "./components/Top"
import { LoadingButton } from "@mui/lab"
import { Link, useNavigate } from "react-router-dom"
import { useContext, useState } from "react"
import UserContext from "../../services/Context/UserContext"
import API from "../../services/API"
import Password from "../Inputs/Password"
import { Warning } from "../Tools/Alerts"
import { txt } from "../../services/translation"

export default function Delete(){

    const {user, setUser} = useContext(UserContext)

    const navigate = useNavigate()

    const [status, setStatus] = useState('ready')

    const statusIs = s => s === status

    const handleSubmit = e => {
        e.preventDefault();

        setStatus('loading')

        API.put('/me/delete', user)
            .then(() => navigate('/logout'))
            .catch(() => setStatus('error'))
        
    }


    return (
        <Layout tab='profile' menu='main'>
            <form onSubmit={handleSubmit}>
                <Stack spacing={3} sx={{maxWidth: 600, margin: 'auto', mt: 3}}>
                    <Top user={user}/>
    
                    <Typography variant='h3'>{txt('accountDeletion')}</Typography>
    
                    <Warning>{txt('irreversibleOperationWarning')}</Warning>
    
                    <Typography>{txt('confirmAccountDeletion')}</Typography>
    
                    <Password
                        value={user.password || ''}
                        onChange={e => setUser({...user, password: e.target.value})}
                        error={statusIs('error') && txt('incorrectPasswordError')}
                        required
                    />
    
                    <Stack direction='row' justifyContent='flex-end' spacing={3}>
                        <Link to='/profile'>
                            <Button>{txt('cancel')}</Button>
                        </Link>
    
                        <LoadingButton
                            variant='contained'
                            type='submit'
                            loading={statusIs('loading')}
                            color='error'
                        >
                            {txt('deleteAccount')}
                        </LoadingButton>
                    </Stack>
                </Stack>
            </form>
        </Layout>
    );
    
}